// useBroadcastListener.js
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getChannel, thisWindowId } from 'services/broadcasting';
import { reduxStore } from 'services/configureStore';

export function useBroadcastListener() {
	const dispatch = useDispatch();

	useEffect(() => {
		const channel = getChannel();

		channel.onmessage = event => {
			const incomingSenderId = event.data.meta.senderId;

			//Listen to the actions sent from the other window
			if (incomingSenderId !== thisWindowId) {
				// console.log(thisWindowId, ' - received action from: ', incomingSenderId, event.data);

				//Only the main window responds (main windows start with 'main-window')
				if (thisWindowId.startsWith('main-window')) {
					if (event.data.type === 'REQUEST_INITIAL_STATE') {
						const state = reduxStore.getState();
						const { opsView, liveTraffic, streaming, map } = state;

						const sanitizedLiveTraffic = {
							...liveTraffic,
							airMeshPusherInstance: null //Functions can't be serialized and sent via postMessage
						};

						channel.postMessage({
							type: 'HYDRATE_REDUX',
							payload: { opsView, liveTraffic: sanitizedLiveTraffic, streaming, map },
							meta: { senderId: thisWindowId }
						});

						return;
					}
				}

				dispatch(event.data);
			}
		};

		return () => {
			channel.close();
		};
	}, [dispatch]);
}
